import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const PearlsOrderProvider = (props) => {
  const api = new API();
  const [pearlsOrderCatList, setPearlsOrderCatList] = useState([]);
  const [pearlsOrderSubCatList, setPearlsOrderSubCatList] = useState([]);
  const [pearlsOrderCatListLoader, setPearlsOrderCatListLoader] = useState(false);
  const [pearlsOrderSubCatListLoader, setOrderSubCatListLoader] = useState(false);
  const [pearlsOrderTableFilter, setPearlsOrderTableFilter] = useState({
    page: 1,
    limit: 100,
  })
  const [pearlsOrderList, setPearlsOrderList] = useState([]);
  const [subCatOrderId, setSubCatOrderId] = useState("");
  const [pearlsOrderListLoader, setPearlsOrderListLoader] = useState(false);
  const fetchPearlsOrderCatList = async () => {
    setPearlsOrderCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearlsorder/categorylist", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setPearlsOrderCatList(res?.data?.data);
        } else {
          setPearlsOrderCatList([]);
        }
        setPearlsOrderCatListLoader(false);
      }));
  }
  const fetchPearlsOrderSubCatList = async (cid) => {
    setOrderSubCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearlsorder/subcategorylist", {
        category_id: cid
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setPearlsOrderSubCatList(res?.data?.data);
        } else {
          setPearlsOrderSubCatList([]);
        }
        setOrderSubCatListLoader(false);
      }));
  }
  const fetchPearlsOrderList = async (data) => {
    setPearlsOrderListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setSubCatOrderId(data?.subcategory_id);
    (await api.getAll("pearlsorder/examtablelist_v3", {
        category_id: data?.category_id,
        subcategory_id: data?.subcategory_id,
        ...pearlsOrderTableFilter
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setPearlsOrderList(res?.data?.data);
        } else {
          Widget.showMessage('error',err?.response?.data?.message);
          setPearlsOrderList([]);
        }
        setPearlsOrderListLoader(false);
      }));
  }

  const fetOrderPearlsSub = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "pearls"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }
  const fetOrderPearlsTopic = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "pearls"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }

   return (
    <Context.Provider value={{
      ...props,
      pearlsOrderCatList, setPearlsOrderCatList,
      pearlsOrderSubCatList, setPearlsOrderSubCatList,
      pearlsOrderCatListLoader, setPearlsOrderCatListLoader,
      pearlsOrderSubCatListLoader, setOrderSubCatListLoader,
      pearlsOrderTableFilter, setPearlsOrderTableFilter,
      pearlsOrderList, setPearlsOrderList,
      pearlsOrderListLoader, setPearlsOrderListLoader,
      fetchPearlsOrderCatList,
      fetchPearlsOrderSubCatList,
      fetchPearlsOrderList,
      fetOrderPearlsSub,
      fetOrderPearlsTopic,
      subCatOrderId, setSubCatOrderId
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default PearlsOrderProvider;

